import {Grid, Card, CardContent, Avatar, Typography, IconButton, Stack, CircularProgress} from "@mui/material";
import {styled} from "@mui/material/styles";
import {isEmpty} from "lodash";
import {useMemo, useRef} from "react";
import {MoreVert} from "@mui/icons-material";
import {useSelector} from "react-redux";
import {selectVendorOrders} from "../../../constant/selectors";

const Cover = styled(Avatar)(({src, alt}) => ({
    alt: `${alt || '...'}`,
    content: `url(${src || '/static/noImage.svg'})`
}))

export default function OrderItem({item}) {
    const anchor = useRef();
    const cover = useMemo(() => isEmpty(item?.imageUrl) ? null : item?.imageUrl, [item?.imageUrl]);
    const {byId = {}} = useSelector(selectVendorOrders)
    const details = useMemo(() => byId[item?.id] || null, [byId, item?.id])
    const loading = useMemo(() => details === null, [details])

    return (
        <Card>
            <CardContent>
                <Grid container>
                    <Grid item xs={1}>
                        <Cover src={cover}/>
                    </Grid>

                    <Grid item xs={7}>
                        <Typography variant={'subtitle1'}>
                            {item?.name}
                        </Typography>
                    </Grid>


                    <Grid item xs={3} hidden={loading}>
                        <Typography variant={'subtitle1'} align={'center'}>
                            {details?.buyPrice}
                        </Typography>
                    </Grid>

                    <Grid item xs={1} hidden={loading}>
                        <Stack direction={'row'} justifyContent={'end'}>
                            <IconButton ref={anchor}>
                                <MoreVert/>
                            </IconButton>
                        </Stack>
                    </Grid>

                    <Grid item xs={4} hidden={!loading}>
                        <Stack direction={'row'} justifyContent={'end'}>
                            <CircularProgress/>
                        </Stack>
                    </Grid>

                </Grid>
            </CardContent>
        </Card>
    )
}